import { camelizeObject, snakizeObject } from '@cvt/helpers/object';


export const mapProfileData = (data: Hub.ProfileApi): Hub.Profile =>
  camelizeObject<Hub.Profile>(data);

export const mapGoalsCrudData = (goals: Hub.Goals): Hub.GoalsApi =>
  snakizeObject(goals) as Hub.GoalsApi;

export const mapEducationProgress = (data: Hub.EducationProgressApi): Hub.EducationProgress =>
  camelizeObject<Hub.EducationProgress>(data);

export const mapGradeResult = (data: Hub.GradeResultApi): Hub.GradeResult =>
  camelizeObject<Hub.GradeResult>(data);

export const mapSitePhoto = (data: Hub.SitePhotoApi): Hub.SitePhoto =>
  camelizeObject<Hub.SitePhoto>(data);

export const mapUtilityBill = (data: Hub.UtilityBillApi): Hub.UtilityBill =>
  camelizeObject<Hub.UtilityBill>(data);
